/**
 * Which application fields the numbered details lists leave out: L1/L2/L3
 * application details, the Admin's and the applicant's View Application,
 * the applicant's payment details and the resubmit preview.
 *
 * Main Khasara No. is only the first part of Khasara No., saved on its own
 * so the form can split the number again (Khasara No. 20/45 keeps 20 here).
 * The applicant form never draws it, and Khasara No. and Manual Sub-Khasara
 * already show both parts, so listing it only repeated part of Khasara No.
 * The value itself is still saved and used elsewhere, for example on the
 * Demand Note.
 */
export const DETAIL_SCREEN_HIDDEN_FIELD_UIDS: readonly string[] = ["main_khasara_no"];

function isEmptyValue(value: unknown): boolean {
  return value === undefined || value === null || String(value).trim() === "";
}

/**
 * Whether a details list shows this field.
 *
 * A field the Admin set to Inactive in Application Fields is left out when
 * this application has no value for it. The screens get their fields from
 * /applications/all-fields, which does not look at Active, and some fields
 * are always listed (PLOT_AND_LAYOUT_FIELD_UIDS), so without this check an
 * Inactive field showed as an empty "-" row. An Inactive field that does
 * hold a value is still listed, so saved data stays visible to reviewers.
 *
 * BEFORE - only the fixed list above was checked:
 *   export function isListedOnDetailScreen(field: { uid: string }): boolean {
 *     return !DETAIL_SCREEN_HIDDEN_FIELD_UIDS.includes(field.uid);
 *   }
 */
export function isListedOnDetailScreen(
  field: { uid: string; active?: boolean },
  application: Record<string, unknown> | null | undefined
): boolean {
  if (DETAIL_SCREEN_HIDDEN_FIELD_UIDS.includes(field.uid)) return false;
  if (field.active === false && isEmptyValue(application?.[field.uid])) return false;
  return true;
}
